import React from "react";
import { Helmet } from "react-helmet";
import ContactInfo from "../components/ContactInfo";
import ContactForm from "../components/ContactForm";
import Map from "../components/Map";
import Breadcrumb from "../components/Breadcrumb";

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Healthtech Solutions</title>
        <meta
          name="description"
          content="Get in touch with HealthTech Solutions Pvt Ltd, a leading AI-enabled digital and IT solutions company. Reach out for web development, software solutions, digital marketing, and IT consulting inquiries."
        />
        <meta
          name="keywords"
          content="AI solutions company, digital marketing agency, SEO services, website development company, software development company, IT consulting services, AI technology solutions"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.healthtechsl.com/contact" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Contact Healthtech Solutions" />
        <meta
          property="og:description"
          content="Get in touch for digital marketing, SEO, AI solutions and software development services."
        />
        <meta
          property="og:image"
          content="https://healthtechsl.com/images/contact-banner.jpg"
        />
        <meta property="og:url" content="https://healthtechsl.com/contact" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Healthtech Solutions" />
        <meta
          name="twitter:description"
          content="Get in touch for digital marketing, SEO, AI solutions and software development services."
        />
        <meta
          name="twitter:image"
          content="https://healthtechsl.com/images/contact-banner.jpg"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Healthtech Solutions",
            "url": "https://healthtechsl.com/contact",
            "description": "Contact Healthtech Solutions for AI powered digital marketing, website development and IT services."
          }
          `}
        </script>

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Healthtech Solutions Pvt Ltd",
            "url": "https://healthtechsl.com",
            "logo": "https://healthtechsl.com/images/logo.png"
          }
          `}
        </script>
        {/* Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-DE4KQ9E1T2"
        ></script>

        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-DE4KQ9E1T2');
            `,
          }}
        />
        {/* Google Tag Manager */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-NJ6DNHM7');
            `,
          }}
        />
        {/* Google Tag Manager (noscript) */}
        <noscript
          dangerouslySetInnerHTML={{
            __html: `
      <iframe 
        src="https://www.googletagmanager.com/ns.html?id=GTM-NJ6DNHM7"
        height="0"
        width="0"
        style="display:none;visibility:hidden">
      </iframe>
    `,
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "How can I contact Healthtech Solutions?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "You can contact us via our website contact form, email, or phone to discuss your requirements.",
                  },
                },
              ],
            }),
          }}
        />
      </Helmet>

      {/* Breadcrumb */}
      <Breadcrumb title="Contact Us" />

      {/* Page Sections */}
      <ContactInfo />
      <ContactForm />
    </>
  );
}
